import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Chicken Katsu',
  source: 'https://www.justonecookbook.com/chicken-katsu/',
  totalTime: time(0, 30),
  servings: 2,
  tags: { type: 'main' },
  ingredients: [
    { name: 'chicken breast', quantity: '10', unit: 'oz',
      note: 'boneless, skinless',
    },
    { name: 'kosher salt', quantity: '1/2', unit: 'tsp' },
    { name: 'black pepper', quantity: '1/8', unit: 'tsp',
      note: 'freshly ground',
    },
    { name: 'neutral oil', quantity: '3', unit: 'cup',
      fixed: true,
      amountNote: 'for deep-frying',
    },
    { name: 'all-purpose flour', quantity: '3', unit: 'tbsp' },
    { name: 'panko breadcrumbs', quantity: '1', unit: 'cup' },
    { name: 'egg', quantity: '1',
      note: 'large',
    },
    { name: 'neutral oil for egg', quantity: '1/2', unit: 'tbsp' },
    { name: 'tonkatsu sauce' },
    { name: 'japanese curry', quantity: '1', unit: 'recipe', customUnit: true,
      recipe: 'japanese-curry',
    },
    { name: 'cooked Japanese short-grain rice', quantity: '2', unit: 'servings', customUnit: true },
    { name: 'fukujinzuke',
      note: 'Japanese red pickled vegetables (optional)',
    },
  ],
  directions: [
    {
      title: 'Butterfly chicken',
      bullets: [
        "Split {chicken breast} horizontally from the side, stopping short of through & open like a book",
        "Cut in half down the center, so each breast becomes 2 thin pieces",
      ],
    },
    {
      title: 'Pound & season',
      bullets: [
        "Pound pieces to even {=fixed 1/4 in}–{=fixed 1/2 in} thickness",
        "Season both sides with {kosher salt} & {black pepper}",
      ],
    },
    {
      title: 'Preheat oil',
      bullets: [
        "Add {neutral oil} to medium heavy-bottomed pot, so oil is at least {=fixed 1 1/2 in} deep",
        "Preheat to {!340F} over medium-low heat",
      ],
    },
    {
      title: 'Bread',
      bullets: [
        "Set up 3 trays: {all-purpose flour}, beaten {egg} & {panko breadcrumbs}",
        "Whisk {neutral oil for egg} into the egg",
        "Dredge chicken in flour & shake off excess, then coat with egg",
        "Coat with panko, pressing gently to adhere & shake off excess",
      ],
    },
    {
      title: 'Deep-fry',
      bullets: [
        "Fry one cutlet at a time",
        "Fry 3 min total, flipping at halfway point, until both sides are golden brown",
        "Hold cutlet vertically over pot a few seconds to drain, then transfer to wire rack",
        "Skim out loose crumbs with fine-mesh strainer before frying the next cutlet",
      ],
    },
    {
      title: 'Serve',
      bullets: [
        "Cut cutlets crosswise into {=fixed 1 in} strips",
        "Serve over {cooked Japanese short-grain rice} with {tonkatsu sauce} or {japanese curry}",
        "Garnish with {fukujinzuke}",
      ],
    },
  ],
};

export default recipe;
